/**
 * Pure builder for an annotation **update** (PUT) body (ADR-034 Inc 6b;
 * feature-spec §7 / §8.2). The label/style editor mutates only the label +
 * style; the kind / geometry / radius are preserved (geometry editing is a
 * later increment). Pure so it's CI-testable.
 *
 * Cross-references:
 *   - ADR-034; feature-spec §7 (labels) / §8.2 (edit).
 *   - @/annotations/use-annotations (the API request shape + the update hook).
 */
import type { Annotation, AnnotationWriteRequest } from "@/annotations/use-annotations";

/** The non-optional label shape the editor holds + sends. */
export type AnnotationLabel = NonNullable<AnnotationWriteRequest["label"]>;
/** The style shape the editor holds + sends. */
export type AnnotationStyle = AnnotationWriteRequest["style"];

/**
 * Build a PUT body that updates an annotation's label + style while preserving
 * its kind / geometry / radius (the editor doesn't move geometry).
 */
export function buildAnnotationWriteBody(
  annotation: Annotation,
  label: AnnotationLabel,
  style: AnnotationStyle,
): AnnotationWriteRequest {
  return {
    kind: annotation.kind,
    geometry: annotation.geometry,
    radius_m: annotation.radius_m,
    style,
    label,
  };
}
